import React from "react";

import { Form, Input, Button, Space } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";

export const InputManualStats = (props) => {
  const { item } = props;

  return (
    <>
      <Form.Item label={item.label}>
        <Form.List name="stats">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Space
                  key={key}
                  style={{
                    display: "flex",
                    marginBottom: 8,
                  }}
                  align="baseline"
                >
                  <Form.Item
                    {...restField}
                    name={[name, "home"]}
                    rules={[
                      {
                        required: true,
                        message: "Missing home stat",
                      },
                    ]}
                  >
                    <Input placeholder="Home stat" />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, "stat"]}
                    rules={[
                      {
                        required: true,
                        message: "Missing stat name",
                      },
                    ]}
                  >
                    <Input placeholder="Stat Name" />
                  </Form.Item>
                  <Form.Item {...restField} name={[name, "away"]}>
                    <Input placeholder="Away stat" />
                  </Form.Item>
                  <MinusCircleOutlined onClick={() => remove(name)} />
                </Space>
              ))}
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined />}
                >
                  Add field
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
      </Form.Item>
    </>
  );
};
